import React from "react";
import { Link } from "react-router-dom";
import { Wheat, ShieldCheck } from "lucide-react";

export default function Footer({ compact = false }) {
  const year = new Date().getFullYear();

  if (compact) {
    return (
      <div className="w-full text-center text-xs text-brand-muted py-4 px-4" data-testid="footer-compact">
        Independent third-party training resource — not affiliated with Panera Bread.{" "}
        <Link to="/disclaimers" className="text-brand font-semibold hover:underline" data-testid="footer-disclaimer-link">
          Disclaimer &amp; Privacy Notice
        </Link>
      </div>
    );
  }

  return (
    <footer className="border-t border-brand-line bg-brand-sidebar/50 mt-auto" data-testid="app-footer">
      <div className="px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 max-w-6xl mx-auto">
        <div className="flex items-start gap-3">
          <div className="h-8 w-8 rounded-lg bg-brand flex items-center justify-center shrink-0">
            <Wheat className="w-4 h-4 text-white" />
          </div>
          <div className="text-xs text-brand-muted leading-relaxed max-w-xl">
            <p className="font-semibold text-brand-ink">The Spread · Panera Coaching</p>
            <p>
              An independent, third-party training resource — <span className="font-medium">not affiliated with, sponsored by, or endorsed by Panera Bread.</span>{" "}
              Created &amp; maintained by James Clarke. Official Panera corporate resources always supersede content here.
            </p>
            <p className="mt-1">© {year} James Clarke. All personal data is kept strictly confidential and never sold.</p>
          </div>
        </div>
        <Link
          to="/disclaimers"
          data-testid="footer-disclaimer-link"
          className="inline-flex items-center gap-2 rounded-full border border-brand-line bg-white px-4 py-2 text-sm font-semibold text-brand hover:bg-brand-sidebar transition-colors shrink-0"
        >
          <ShieldCheck className="w-4 h-4" /> Disclaimer &amp; Privacy Notice
        </Link>
      </div>
    </footer>
  );
}
